<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/Contact')">联系我们</a></p>
        </div>
    </div>
    <div class="zhu-contact">
        <h3>联系我们</h3>
        <div class="contact-body">
            <div class="body-left">
                <h4>公司名称：开封市政泉艺术品鉴定有限公司</h4>
                <p>公司地址：河南省开封市鼓楼区古玩大市场政泉评级</p>
                <p>热线电话：178 3784 4475</p>
                <p>企业邮箱：zhengquanpingji@163.com</p>  
            </div>

            <div class="body-right">
                <div class="demo-image__preview">
                    <el-image
                        :src="url"
                        :preview-src-list="srcList"
                        :initial-index="0"
                        fit="cover"
                        >
                    </el-image>
                    <h5>(点击图片放大)</h5>
                </div>
            </div>
        </div>
        

    </div>
</template>

<script>
export default {
    data () {
        return {
            url: require('../assets/img/address/companyaddress.jpg'),
            //轮播图
            srcList : [
                require('../assets/img/address/companyaddress.jpg')
            ],
        }
    }
}
</script>

<style lang="scss" scoped>
.demo-image__error .image-slot {
  font-size: 30px;
}
.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}
//-------------------------------小跳转菜单
.top-tags {
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}


.zhu-contact {
    width: 1400px;
    margin: 0 auto;
    @media only screen and (max-width: 1400px) {
        width: 100%;
    }

    h3 {
        @media only screen and (max-width: 810px) {
            width: 90%;
            margin: 20px 5%;
        }
        font-size: 24px;
        text-align: left;
        margin: 20px 96px;
        padding: 10px 0;
        border-bottom: 1px solid #DFDFDF;
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 48px;
            bottom: -1px;
            width: 100px;
            height: 2px;
            margin-left: -50px;
            background-color: #409EFF;
        }
    }

    .contact-body {
        display: flex;
        @media only screen and (max-width: 1060px) {
            display: block;
        }
        
        .body-left {
            @media only screen and (max-width: 1060px) {
               width: 90%;
               margin-bottom: 30px;
            }
            @media only screen and (max-width: 810px) {
                padding-left: 5%;
            }
            text-align: left;
            padding-left: 110px;
            width: 30%;

            @media only screen and (max-width: 470px) {
                h4 {
                    width: 80%;
                }
                p {
                    width: 80%;
                }
            }
            h4 {
                font-size: 20px;
                width: 400px;
                @media only screen and (max-width: 810px) {
                    font-size: 18px;
                }
                @media only screen and (max-width: 470px) {
                    width: 100%;
                }
            }
            p {
                margin-top: 20px;
                font-size: 16px;
                width: 400px;
                @media only screen and (max-width: 810px) {
                    font-size: 14px;
                }
                @media only screen and (max-width: 470px) {
                    width: 100%;
                }
            }
        }
        .body-right {
            @media only screen and (max-width: 620px) {
               width: 100%;
            }
            h5 {
                cursor: default;
                color: #666666;
            }

        }
        

    }

}
    
</style>